import "./tarifsFormula.css";

import PageButton from "../../../components/general/PageButton";

function TarifsFormula({ scrollToDetails, scrollToMap }) {
  return (
    <div className="tarifs-formula-main">
      <div className="tarifs-formula-border-top"></div>
      <div className="tarifs-formula-title">
        <h2>TARIFS DES PRESTATIONS</h2>
      </div>
      <div className="tarifs-formula-formula">
        <p>
          🚗 Intervention à domicile possible (supplément selon la distance).
        </p>
        <p>🔍 Diagnostic : 30€</p>
        <p>🛠 Prestations : à partir de 30€, selon le service demandé.</p>
      </div>
      <div className="tarifs-formula-reductions">
        Tarifs réduit (-25%) pour les étudiants, demandeurs d'emploi, RSA,
        personnes en situation de handicap et associations.
      </div>
      <div className="tarifs-formula-details">
        <PageButton onClickEffect={scrollToDetails}>
          Details des prestations
        </PageButton>
      </div>
      <div className="tarifs-formula-details">
        <PageButton onClickEffect={scrollToMap}>
          Estimation du coût du déplacement
        </PageButton>
      </div>
    </div>
  );
}

export default TarifsFormula;
